// extracted by mini-css-extract-plugin
export default {"alatau":"styles_alatau__lECs-","alatauContent":"styles_alatauContent__raxwL"};